export type Project = {
  title: string;
  description: string;
  technologies: string[];
  imageUrl: string;
  link: string;
};

export const projects: Project[] = [
  {
    title: 'Personal Website',
    description:
      'A personal portfolio website to showcase my projects and skills.',
    technologies: ['React', 'TypeScript', 'MUI'],
    imageUrl: '/images/projects/personal-website.png',
    link: 'https://jovannimosca.com',
  },
  {
    title: 'Home Lab',
    description:
      'Documentation and setup for my personal home lab environment.',
    technologies: ['Docker', 'Terraform', 'Ansible', 'Proxmox'],
    imageUrl: '/images/projects/home-lab.png',
    link: 'https://github.com/jovannimosca/homelab',
  },
  {
    title: 'Web Downloader',
    description:
      'A full-stack application with a React frontend, a Python Flask backend, and a PostgreSQL database to download and manage files from the web.',
    technologies: [
      'React',
      'TypeScript',
      'MUI',
      'Python',
      'Flask',
      'PostgreSQL',
    ],
    imageUrl: '/images/projects/web-downloader.png',
    link: 'https://github.com/jovannimosca/web-downloader',
  },
  {
    title: 'Flipper Zero BadUSB Exfiltrator',
    description:
      'A script for the Flipper Zero that orchestates BadUSB attacks and exfiltrates data to Flipper.',
    technologies: [
      'Flipper Zero',
      'BadUSB',
      'DuckyScript',
      'JavaScript',
      'TypeScript',
    ],
    imageUrl: '/images/projects/flipper-badusb-exfil.png',
    link: 'https://github.com/jovannimosca/flipper-badusb-exfil',
  },
  {
    title: 'Queer Students - South Africa and the US',
    description:
      'A research project comparing the experiences of queer students in South Africa and the United States, focusing on social acceptance, mental health, and educational challenges.',
    technologies: ['Research', 'Academic Writing', 'HTML', 'CSS'],
    imageUrl: '/images/projects/queer-students.png',
    link: 'https://queerstudents.justoutof.site/',
  },
];
